<template>
  <div>
    <div class="page-header">
      <div class="add-item d-flex">
        <div class="page-title">
          <h4>{{ $t("role_list") }}</h4>
        </div>
      </div>

      <div class="page-btn" v-if="can('rbac.role', 'W')">
        <router-link to="/roles/create/" class="btn btn-added">
          <i class="ti ti-circle-plus me-2 text-white"></i>{{ $t("add_new_role") }}
        </router-link>
      </div>
    </div>

    <div class="card table-list-card">
      <div class="card-body">
        <div class="table-responsive">

          <!-- Table -->
          <DataTable v-if="roles.length" :tableId="'groupTable'">
            <thead>
              <tr>
                <th>Role name</th>
                <th>User type</th>
                <th>Descriptions</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="g in roles" :key="g.id">
                <td>{{ g.name }}</td>
                <td>{{ g.user_type_name }}</td>
                <td>{{ g.description}}</td>
                <td class="action-table-data">
                  <div class="edit-delete-action" v-if="can('rbac.role', 'E')">
                    <router-link
                      :to="{ name: 'RoleEdit', params: { id: g.id } }"
                      class="btn btn-added"
                    >
                      <i class="ti ti-edit me-2"></i>
                      {{ $t("edit_role") }}
                    </router-link>
                  </div>
                </td>
              </tr>
            </tbody>
          </DataTable>

          <!-- No Data State -->
          <div v-else class="d-flex flex-column align-items-center justify-content-center p-5 bg-light rounded shadow-sm">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#6c757d" class="mb-3" viewBox="0 0 16 16">
              <path d="M8 0a8 8 0 1 0 8 8A8.009 8.009 0 0 0 8 0zm0 15A7 7 0 1 1 15 8a7.008 7.008 0 0 1-7 7z"/>
              <path d="M5.354 4.646a.5.5 0 0 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z"/>
            </svg>
            <h5 class="text-muted">No roles Found</h5>
            <p class="text-secondary small">roles will appear here automatically after migration.</p>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { can as canAccess } from "@/helpers/permission";
import apiUrls from '@/urls';
import DataTable from '@/components/common/DataTable.vue';

export default {
  inject: ["globalLoading"],
  components: { DataTable },

  data() {
    return {
      roles: [],
    };
  },

  methods: {
    async fetchRoles() {
      this.globalLoading(true);

      try {
        const response = await this.$axios.get(apiUrls.roles.get);
        this.roles = response.data.results || response.data || [];
      } catch (error) {
        console.error("Error fetching group data:", error);
      } finally {
        this.globalLoading(false);
      }
    },

    can(code, requiredLevel) {
      return canAccess(code, requiredLevel);
    },
  },

  created() {
    this.fetchRoles();
  }
};
</script>
